import './styles.css';
import { config } from './config';
import { PokedexApp } from './ui/app';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('找不到应用挂载节点。');

const theme = config.ui.theme;
document.documentElement.style.setProperty('--shell', theme.shell);
document.documentElement.style.setProperty('--shell-dark', theme.shellDark);
document.documentElement.style.setProperty('--screen', theme.screen);
document.documentElement.style.setProperty('--ink', theme.ink);
document.documentElement.style.setProperty('--glow', theme.glow);

new PokedexApp(root);

document.title = config.app.title;

if (config.deployment.registerServiceWorker && 'serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`, {
      updateViaCache: 'none',
    });
  });
}
